module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#c1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1"), _c('br'), _c('em', [_vm._v("Breakfast")])])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/3-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "chaptext"
  }, [_vm._v("From steel-cut oats packed with berries to light and fluffy cinnamon-coated rolls, fried eggs over hash browns, and spicy charred sausage with avocado, breakfast casseroles come in all shapes and sizes.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-440b5e2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 81
// module chunks = 0